module.exports = __webpack_public_path__ + "static/img/8.aa39587.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/8.png
// module id = QWzk
// module chunks = 0